import React from 'react';
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import Card from "../../../shared/components/Card";
import CardBody from "../../../shared/components/CardBody";
import Row from "../../../shared/components/Row";
import Accordion from "../../../shared/components/accordion/Accordion";
import AccordionItem from "../../../shared/components/accordion/AccordionItem";
import {I18nUtils} from "../../../../i18n/I18nUtils";
import * as exportOutsourceDocsActions from "../../actions/exportOutsourceDocsActions";
import RouterUtils from "../../../shared/routing/RouterUtils";
import {PsRoutes} from "../../../shared/routing/Routes";
import DocumentsTabTable from "../../../shared/components/tabs/documents/DocumentsTabTable";
import Tab from "../../../shared/components/Tab";
import Paginator from "../../../shared/components/Paginator";
import MachinesTabTable from "../../../shared/components/tabs/machines/MachinesTabTable";
import WorkersTabTable from "../../../shared/components/tabs/workers/WorkersTabTable";
import {Link} from "react-router-dom";

const DEFAUL_STATE = {
  outsourceDocumentsPage: 1,
  workersPage: 1,
  machinesPage: 1,
  monthlyDocumentsPage: 1,
  linkedDocumentsPage: 1,
};

class ExportOutsourceDocsCardConfirm extends React.Component {

  constructor(init){
    super(init);

    this.state = DEFAUL_STATE;

    this.exportDocumentation = this.exportDocumentation.bind(this);
  }

  exportDocumentation() {
    this.props.exportOutsourceDocsActions.exportDocumentation(
      this.props.outsource,
      this.props.outsourceDocuments.map(document => document.id),
      this.props.workers.map(worker => worker.id),
      this.props.machines.map(machine => machine.id),
      this.props.monthlyDocuments.map(document => document.id),
      this.props.linkedDocuments.map(document => document.id),
    );
  }

  renderAccordionOutsourceDocuments(){
    if (this.props.outsourceDocuments.length > 0) {
      return (
        <AccordionItem
          id={'1'} accordionId={'export'}
          title={I18nUtils.tr('TR_DOCUMENTOS_SUBCONTRATA').toUpperCase() + " (" + this.props.outsourceDocuments.length + ")"}
          expanded={false}
        >
          <Row clearfix={true}>
            <Tab>
              <DocumentsTabTable
                id={'EXPORT_DOCUMENTS_CONFIRM_DOCUMENTS_OUTSOURCE'}
                data={Paginator.buildData(this.props.outsourceDocuments, this.state.outsourceDocumentsPage, 10)}
              />
              <Paginator
                onPage={(page) => this.setState({outsourceDocumentsPage: page})}
                data={Paginator.buildPagerData(this.props.outsourceDocuments, this.state.outsourceDocumentsPage, 10)}
              />
            </Tab>
          </Row>
        </AccordionItem>
      );
    }
  }

  renderAccordionWorkers(){
    if (this.props.workers.length > 0) {
      return (
        <AccordionItem id={'2'} accordionId={'export'} title={I18nUtils.tr('TR_TRABAJADORES').toUpperCase() + " (" + this.props.workers.length + ")"} >
          <Row clearfix={true}>
            <Tab>
              <WorkersTabTable
                data={Paginator.buildData(this.props.workers, this.state.workersPage)}
              />
              <Paginator
                onPage={(page) => this.setState({workersPage: page})}
                data={Paginator.buildPagerData(this.props.workers, this.state.workersPage)}
              />
            </Tab>
          </Row>
        </AccordionItem>
      );
    }
  }

  renderAccordionMachines(){
    if (this.props.machines.length > 0) {
      return (
        <AccordionItem id={'3'} accordionId={'export'} title={I18nUtils.tr('TR_MAQUINARIA').toUpperCase() + " (" + this.props.machines.length + ")"} >
          <Row clearfix={true}>
            <Tab>
              <MachinesTabTable
                data={Paginator.buildData(this.props.machines, this.state.machinesPage)}
              />
              <Paginator
                onPage={(page) => this.setState({machinesPage: page})}
                data={Paginator.buildPagerData(this.props.machines, this.state.machinesPage)}
              />
            </Tab>
          </Row>
        </AccordionItem>
      );
    }
  }

  renderAccordionMonthlyDocuments(){
    if (this.props.monthlyDocuments.length > 0) {
      return (
        <AccordionItem id={'4'} accordionId={'export'} title={I18nUtils.tr('TR_DOCUMENTOS_MENSUALES').toUpperCase() + " (" + this.props.monthlyDocuments.length + ")"} >
          <Row clearfix={true}>
            <Tab>
              <DocumentsTabTable
                id={'EXPORT_DOCUMENTS_CONFIRM_MONTHLY_DOCUMENTS'}
                data={Paginator.buildData(this.props.monthlyDocuments, this.state.monthlyDocumentsPage)}
              />
              <Paginator
                onPage={(page) => this.setState({monthlyDocumentsPage: page})}
                data={Paginator.buildPagerData(this.props.monthlyDocuments, this.state.monthlyDocumentsPage)}
              />
            </Tab>
          </Row>
        </AccordionItem>
      );
    }
  }

  renderAccordionLinkedDocuments(){
    if (this.props.linkedDocuments.length > 0) {
      return (
        <AccordionItem id={'5'} accordionId={'export'} title={I18nUtils.tr('TR_DOCUMENTOS_VINCULADOS').toUpperCase() + " (" + this.props.linkedDocuments.length + ")"} >
          <Row clearfix={true}>
            <Tab>
              <DocumentsTabTable
                id={'EXPORT_DOCUMENTS_CONFIRM_LINKED_DOCUMENTS'}
                data={Paginator.buildData(this.props.linkedDocuments, this.state.linkedDocumentsPage)}
              />
              <Paginator
                onPage={(page) => this.setState({linkedDocumentsPage: page})}
                data={Paginator.buildPagerData(this.props.linkedDocuments, this.state.linkedDocumentsPage)}
              />
            </Tab>
          </Row>
        </AccordionItem>
      );
    }
  }

  render() {
    return (
      <Row>
        <Card colWidth={'col-md-12'} loading={this.props.loading} >

          <CardBody>

            <Accordion id={'export'}>

              {this.renderAccordionOutsourceDocuments()}
              {this.renderAccordionWorkers()}
              {this.renderAccordionMachines()}
              {this.renderAccordionMonthlyDocuments()}
              {this.renderAccordionLinkedDocuments()}

            </Accordion>

            <div className="row">
              <div className="col-xs-6">
                <Link
                  to={RouterUtils.generateRoute(PsRoutes.MY_OUTSOURCES_DOCUMENTS_EXPORT, {id: this.props.outsource.id})}
                  className={'btn btn-lg waves-effect waves-float'}
                >{I18nUtils.tr('TR_CANCELAR').toUpperCase()}</Link>
              </div>
              <div className="col-xs-6">
                <div className="text-right">
                  <a
                    className="btn btn-info btn-lg waves-effect waves-float"
                    onClick={this.exportDocumentation}
                  >{I18nUtils.tr('TR_EXPORTAR').toUpperCase()}</a>
                </div>
              </div>
            </div>

          </CardBody>
        </Card>
      </Row>
    );
  }

}

const mapStateToProps = (state, ownProps) => {
  return {
    outsource: state.exportOutsourceDocs.outsource,
    loading: state.exportOutsourceDocs.loading,
    outsourceDocuments: state.exportOutsourceDocs.outsourceDocuments,
    workers: state.exportOutsourceDocs.workers,
    machines: state.exportOutsourceDocs.machines,
    monthlyDocuments: state.exportOutsourceDocs.monthlyDocuments,
    linkedDocuments: state.exportOutsourceDocs.linkedDocuments,
  }
};

const mapDispatchToProps = dispatch => ({
  exportOutsourceDocsActions: bindActionCreators(exportOutsourceDocsActions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(ExportOutsourceDocsCardConfirm)



// WEBPACK FOOTER //
// ./src/app/outsource/components/export/ExportOutsourceDocsCardConfirm.js